import { useMemo } from 'react';

import type { List } from 'immutable';
import type { ImmutableEntity, TaxonomyEntity } from '@uncinc/react-drupal-core/types';

const useTaxonomyParentIds = (entities: List<ImmutableEntity<TaxonomyEntity>>) => (
  useMemo(() => {
    const parents: Set<number> = new Set();

    // Loop over all the entities.
    entities.forEach((term) => {
      const parentId = term.getIn(['parent', 0, 'target_id']);

      // If an entity has a parent, save the parent id.
      if (parentId) {
        parents.add(parentId);
      } else {
        // If an entity doesn't have a parent, save the it's own id.
        parents.add(term.getIn(['tid', 0, 'value']));
      }
    });

    // Return a de-deduplicated array of parent id's.
    return [...parents];
  }, [entities])
);

export default useTaxonomyParentIds;
